export default {
  pageCustomManager: {
    getList: 'api/pageCustomManager/list',
    addConfig: 'api/pageCustomManager/addConfig',
    updateConfig: 'api/pageCustomManager/updateConfig',
    delConfigs: 'api/pageCustomManager/delConfigs',
    changeStatus: 'api/pageCustomManager/changeStatus',
    getPageConfig: 'api/pageCustomManager/getConfig'
  }
}